import { render, staticRenderFns } from "./ShipsPiRightship.vue?vue&type=template&id=a23d3d8a&scoped=true&"
import script from "./ShipsPiRightship.vue?vue&type=script&lang=js&"
export * from "./ShipsPiRightship.vue?vue&type=script&lang=js&"
import style0 from "./ShipsPiRightship.vue?vue&type=style&index=0&id=a23d3d8a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a23d3d8a",
  null
  
)

export default component.exports